<div class="modal fade in" tabindex="-1" data-backdrop="false" role="dialog" aria-labelledby="myLargeModalLabel" *ngIf="showSmsModal"
	id="modalPopUp">
	<div class="modal-dialog modal-dialog-open">
		<div class="modal-content">
			<!-- Modal header -->
			<div class="modal-header" style="background: #5E6D7F">
				<h4 class="modal-title" id="myModalLabel" translate>
					Send.SMS.title
					<span class="pointer-cursor float-right" (click)="closeModal()">
						<i class="fa fa-times" aria-hidden="true"></i>
					</span>
				</h4>
			</div>
			<div class="modal-body customer-sms">
                <div class="sms-template-wrapper">
                    <app-use-template [screen]="'sms_template'"
                                      themeName="compact"
                                      [screenLabel]="smsScreenLabel"
                                      [showAddNewTemplate]="false"
                                      (selectedItem)="selectedsmsTemplate($event)"
                                      (cancelEvent)="cancelTemplate()"
                    >
                    </app-use-template>
                </div>
				<!-- Sms template -->
                <!--				<div class="sms-template-wrapper"-->
                <!--					[style.background-color]="smsTemplateList?.length==0 ? '#ffffff' : '#F2F2F2'">-->
                <!--					<ng-container *ngIf="smsTemplateList?.length==0">-->
                <!--						<div class="no-results with-large-top-margin">-->
                <!--							<div class="warning-icon-wrap with-info-icon">-->
                <!--								<span class="ss-info icon fix-left"></span>-->
                <!--							</div>-->
                <!--						</div>-->
                <!--						<div class="warning-message ng-binding text-align-center" translate>-->
                <!--							No.available.SMS.templates-->
                <!--						</div>-->
                <!--						<div class="template-footer">-->
                <!--							<span class="cancel-button pointer-cursor float-right" (click)="cancelTemplate()"-->
                <!--								translate>Cancel</span>-->
                <!--						</div>-->
                <!--					</ng-container>-->
                <!--					<ng-container *ngIf="smsTemplateList?.length!=0">-->
                <!--						<div class="template-header" translate>-->
                <!--							Available.templates-->
                <!--						</div>-->
                <!--						<div class="template-search">-->
                <!--							<div class="search">-->
                <!--								<span class="fa fa-search template-search-top"></span>-->
                <!--								<input id="smsTemplateId" placeholder="Search" class="search-width"-->
                <!--									(keyup)="searchSmsTemplates($event)">-->
                <!--							</div>-->
                <!--						</div>-->
                <!--						<ul class="sms-template-list" *ngIf="smsTemplateList?.length > 0">-->
                <!--							<li class="template-data" *ngFor="let template of smsTemplateList">-->
                <!--								<span class="template-name">{{template?.templateName}}</span>-->
                <!--								<span class="template-select" (click)="selectedsmsTemplate(template?.id)"-->
                <!--									translate>Select</span>-->
                <!--							</li>-->
                <!--						</ul>-->
                <!--						<ng-container *ngIf="!(smsTemplateList?.length > 0)">-->
                <!--							<div class="sms-template-list">-->
                <!--								<div class="warning-icon-wrap with-info-icon">-->
                <!--									<span class="ss-info icon fix-left"></span>-->
                <!--								</div>-->
                <!--								<div class="warning-message ng-binding text-align-center" translate>-->
                <!--									No.Record.Found.Search-->
                <!--								</div>-->
                <!--							</div>-->
                <!--						</ng-container>-->
                <!--						<div class="template-footer">-->
                <!--							<span class="cancel-button pointer-cursor float-right" (click)="cancelTemplate()"-->
                <!--								translate>Cancel</span>-->
                <!--						</div>-->
                <!--					</ng-container>-->
                <!--				</div>-->
				<!-- SMS -->
				<ng-container>
					<form *ngIf="smsForm" [formGroup]="smsForm">
						<select autofocus class="select-blk full-width-select2" placeholder="To"
							formControlName="contactTelephoneId">
							<option hidden value="" disabled selected>To</option>
							<option *ngIf="!(customerSmsDetails?.length > 0)" class="no-contact-found" disabled > <span>No matched found</span> </option>
							<ng-container *ngFor="let contact of customerSmsDetails">
								<optgroup label="{{contact.contactName}}">
									<option *ngFor="let details of contact?.contacts" value="{{details?.id}}">
										{{details?.contactNumber}}
									</option>
								</optgroup>
							</ng-container>
						</select>
						<textarea formControlName="message" id="sms-template-message"  [ngStyle]="{'height': '320px' }"
							class="form-blk tiny-mce-single-line-input-wrapper"></textarea>
					</form>
				</ng-container>
			</div>
			<div class="modal-footer">
				<div class="row-fluid">
					<div class="float-left">
						<button class="btn template-button" (click)="showTemplateOptions()" translate>
							Use.template
						</button>
						<span  *ngIf="smsInputTextLength >= 1" class="text-length-style">{{smsInputTextLength}} characters</span>
					</div>
					<div class="float-right">
						<span *ngIf="scheduleActivity"class="float-left">
							<div class="schedule-check" *access = "['ScheduleActivity.writeaccess']" >
								<label class="checkbox-button checkbox-text-center" for="completeScheduleActivity">
									<input class="checkbox-button__input" type="checkbox" id="completeScheduleActivity"
										[checked]="scheduled" (change)="isScheduledActivity($event)" />
									<span class="checkbox-button__control"></span>
									<span class="checkbox-button__label" translate="">Schedule.new.activity</span>
								</label>
							</div>
						</span>
						<button class="btn disgard-button" (click)="closeModal()" translate>
							Discard
						</button>
						<button class="btn btn-primary" (click)="sendSms()" [disabled]="!smsForm?.valid || saveDisabled"
							translate>
							Send
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
